import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {tagsList_template} from "../components/templates/tagsList_template";
import {datasetsList_template} from "../components/templates/datasetsList_template";

import {header} from "./header";
import {tagTypes} from "./tagTypes";

declare var ko: any;
declare var page: any;

export class tags extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected elementsList: tagsList_template;
    protected pagination: pagination_template;

    protected getModuleName(){

        return "tags";
    }


    /*
    * Overrides
    * parent function is legacy method of persisting page filters and breaks sub-template bindings.
    */
    protected loadSavedViewModule() {
        let saved_viewModel = this.getVnAppZone().getGlobal(this.getModuleName() + "_viewModel")
        if(saved_viewModel){
            // delete tagStore
            // this forces bindings to be applied on tagStore's child templates
            if(saved_viewModel.tagStore) {
                delete saved_viewModel.tagStore
            }
            this.loadViewModelFromViewModel(saved_viewModel);
        }
        this.getVnAppZone().removeGlobal(this.getModuleName() + "_viewModel");
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.elementsList = new tagsList_template("list", this.viewModel, this);
        this.template = this.elementsList;

        // only show import button if Tag Manager or Admin
        let vnApp = this.getVnAppZone().app;
        let roles = vnApp.loggedUser.user.valnet_user.roles;

        let showImportButton = false;
        let showAddTagButton = false;

        for(let r of roles ){
            if(r.id === 1) {
                showImportButton = true;
                showAddTagButton = true;
            } else {
                for(let s of r.sections) {
                    console.log(s.section.name);
                    if (s.section.name === "tag_import" && s.access_arr.includes("w")) {
                        showImportButton = true;
                    }
                    if (s.section.name === "tag_edit" && s.access_arr.includes("w")) {
                        showAddTagButton = true;
                    }
                }
            }

            if(showImportButton) {
                break;
            }
        }
        this.elementsList.setShowImportButton(showImportButton);
        this.elementsList.setShowAddTagButton(showAddTagButton);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Tags List");

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.elementsList.setIdBrand(idBrand);
        }

        this.elementsList.setActiveFilterItems([
            {id: 1, name: "Yes"},
            {id: 0, name: "No"},
        ])
        
        this.elementsList.setAvailableFilterItems([
            {id: 1, name: "Yes"},
            {id: 0, name: "No"},
        ])

        this.updateViewModelFromPath();
        this.getSearchPresetsListData();

        this.setDefaultStatusFilters();
        this.filterByUrl();
    }

    public showSelectableTags(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected tagsListReorder(){

        this.filterList();
    }

    protected filterDropdownOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected getMemoryViewModel(){
        let templateViewModel = this.elementsList.getTemplateViewModel();

        delete templateViewModel.tags;

        return templateViewModel;
    }

    protected filterMultipleSelectorOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let subViewModel = this.elementsList.getViewModelForRequest();

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/tags/get';
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if(idBrand) {
            usrReq_url = '/api/brand/' + idBrand + "/tags/get/";
        }

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        
        this.sendFilterCall(
            usrReq_url,
            subViewModel,
            this.onFilterRequestReturn,
            XMLHttpRequestHandler_requestType.GET,
            'tags-list',
            this.elementsList.builtTemplate.children.namedItem("list-results")
        );

    }

    protected onFilterRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            });
        }
    }

    // update the module list using the objects list
    protected updateList(responseParsed: any){
        let brandId = this.getBrandId();
        let mainUrl = '/categorization/tags/view/';
        if (brandId) {
            mainUrl = '/brand/' + brandId + '/categorization/tags/view/';
        }


        // set Jobs list
        let tagsToSet = [];
        for (let item of responseParsed.data) {
            tagsToSet.push( {
                id: item.id,
                emakiView: mainUrl + item.id + '/',
                name: item.referenceDescription ? `${item.name} (${item.referenceDescription})` : item.name,
                slug : item.slug,
                type: item.tagType ? `${item.tagType} ${item.formattedDataset}` : '',
                articleCount: item.articleCount ? item.articleCount : '0',
                description: item.description ? item.description : '',
                isSelectable: (item.isSelectable && item.isSelectable != "0"),
            } )
        }

        this.elementsList.setTags(tagsToSet);

        let usrReq_url: string = '/api/tags/get-tags-list';
        if(brandId) {
            usrReq_url = '/api/brand/' + brandId + "/tags/get/-tags-list";
        }

        let execTime = Math.round((new Date().getTime() - this.XHRHdls[usrReq_url].requestStartTime)/1000*100)/100;
        this.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

        // update the paginator
        this.viewModel.list.pagination.itemCount(responseParsed.totalCount);
    }

    protected viewTag(id){

        this.saveViewModule(this.getMemoryViewModel());
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let url = '/categorization/tags/view/' + id;
        if (idBrand) {
            url = '/brand/' + idBrand + "/categorization/tags/view/" + id;
        }
        page(url);
    }

    protected createTag(){

        this.saveViewModule(this.getMemoryViewModel());
        page('/categorization/tags/add/');
    }

    protected importTags(){
        this.saveViewModule(this.getMemoryViewModel());
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let urlBrand = idBrand ? `/brand/${idBrand}` : '';

        page(`${urlBrand}/categorization/tags/import/`);
    }

    protected getTagTypesSuggestion(keyword,idElement){
        if( "getTagTypesSuggestion" in this.XHRHdls ){
            this.XHRHdls["getTagTypesSuggestion"].cancelAndReset();
        }
        const subViewModel = {filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = "/api/search/tag/type/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getTagTypesSuggestion']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getTagTypesSuggestion'].onReadyStateFunction = this.onGetTagTypesSuggestionReturn;
        this.XHRHdls['getTagTypesSuggestion'].execute();
    }

    protected onGetTagTypesSuggestionReturn(req, obj){
        return function () {
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                const tagTypes = responseParsed.data.tagTypes;
                obj.elementsList.setTagTypeFilter(tagTypes)

            });
        }
    }

    private getBrandId() {
        return this.getVnAppZone().getApp().params.idBrand;
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subVM = JSON.parse(ko.toJSON(this.elementsList.getViewModelForRequest()));
        let url: string = '/api/search_preset/get/';
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(subVM)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(url, params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.elementsList.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected filterByUrl(){

        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters){

        this.elementsList.setViewModelFromRequest(filters);
        this.filterList();
    }
    
    protected setDefaultStatusFilters(){
        this.elementsList.setDefaultFilters();
    }

    protected getDatasetSuggestion(keyword, limit = null, restrictOwnedTagTypes = false) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {
            keyword: keyword,
            limit: limit,
            restrictOwnedTagTypes: restrictOwnedTagTypes,
        };
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '';
        if (idBrand) {
            usrReq_url = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/dataset/";
        }else{
            usrReq_url = "/api/search/tag/dataset/";
        }
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetDatasetSuggestionReturn;
        this.XHRHdl.execute();

    }

    protected onGetDatasetSuggestionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
            let responseParsed = JSON.parse(req.request.response);
            let datasets = responseParsed.data.templateTypes;

            obj.elementsList.setDatasetFilter(datasets);
            });
        };
    }

    protected getTagTypeByDatasetId(idDataset){
        //if (this.XHRHdl) {
        //    this.XHRHdl.cancelAndReset();
        //}

        let subViewModel = {
            idDataset: idDataset
        };

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '';
        if(idBrand) {
            usrReq_url = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/types/get_by_dataset_id/" + idDataset + "/";
        }else{
            usrReq_url = "/api/search/tag/types/get_by_dataset_id/" + idDataset + "/";
        }
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetTagTypeByDatasetIdReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagTypeByDatasetIdReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
            let responseParsed = JSON.parse(req.request.response);
            let tagTypes = responseParsed.data;

            obj.elementsList.setTagTypeDropdown(tagTypes);
            
            });
        };
    }
    public deleteAllSelectedTagType() {
        this.elementsList.deleteAllSelectedTagType();
      }

}


// WEBPACK FOOTER //
// ./js/modules/tags.ts